var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalHelmet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2503 7.08333C15.0003 4.16667 12.494 2.5 9.50416 2.5C5.17581 2.5 1.66699 6.03459 1.66699 10.3947C1.66699 13.2427 3.16395 15.7383 5.40847 17.1269C5.89139 17.4257 6.28919 17.5 6.8558 17.5H9.80283C10.9776 17.5 11.9299 16.5673 11.9299 15.4167C11.9299 14.2661 10.9776 13.3333 9.80283 13.3333C9.47424 13.3333 8.85958 13.4571 8.62816 13.1889C8.50349 13.0444 8.53024 12.8638 8.58366 12.5026C8.94933 10.0303 13.5317 9.58333 16.214 9.58333C16.8477 9.58333 17.4813 8.87917 17.9366 8.21823C18.2547 7.75638 18.4137 7.52544 18.2937 7.30439C18.1737 7.08333 17.8707 7.08333 17.2646 7.08333H16.2503ZM16.2503 7.08333H12.5581H16.2503Z",
    fill: "#305D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75649 15.3691H9.75049",
    stroke: "#88E9BA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0103 12.5039V17.1505M18.3336 14.8272H13.687",
    stroke: "#305D61",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalHelmet);
export default __webpack_public_path__ + "static/media/additionalHelmet.77c8e4ffffd4ef5d5098d68c04216446.svg";
export { ForwardRef as ReactComponent };